"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js/object/define-property");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.rSelectTextarea = exports.rNoContent = exports.rInput = exports.rCRLF = exports.baseConfig = exports.SUPPORTED_PREPARED_DATA_TYPES = exports.SUPPORTED_METHODS = exports.CONTENT_TYPE_JSON = exports.CONTENT_TYPE_FORM_URLENCODED = void 0;
/**
 * Base config for global
 *
 * @type {object} baseConfig
 * @type {string} baseConfig.baseURL The base path in which to start requests, offering relative paths for individual requests
 */
const baseConfig = {
  baseURL: '',
  serializeArray: true
};
exports.baseConfig = baseConfig;
const CONTENT_TYPE_FORM_URLENCODED = 'application/x-www-form-urlencoded;charset=utf-8';
exports.CONTENT_TYPE_FORM_URLENCODED = CONTENT_TYPE_FORM_URLENCODED;
const CONTENT_TYPE_JSON = 'application/json;charset=utf-8';

/**
 * Regular Expression to check for whole instance of 'get' or 'head' with case-insensitivity
 */
exports.CONTENT_TYPE_JSON = CONTENT_TYPE_JSON;
const rNoContent = /^(get|head)$/i;

/**
 * Regular Expression to check for line feed with optional carriage return
 */
exports.rNoContent = rNoContent;
const rCRLF = /\r?\n/g;

/**
 * Regular Expression to check input types for valid type
 */
exports.rCRLF = rCRLF;
const rInput = /^(?:color|date|datetime|datetime-local|email|hidden|month|number|password|range|search|tel|text|time|url|week)$/i;

/**
 * Regular Expression to check nodeName for select or textarea
 */
exports.rInput = rInput;
const rSelectTextarea = /^(?:select|textarea)/i;

/**
 * List of HTTP methods that are supported through this Ajax implementation
 *
 * @type {array}
 */
exports.rSelectTextarea = rSelectTextarea;
const SUPPORTED_METHODS = ['delete', 'get', 'head', 'options', 'patch', 'post', 'put'];

/**
 * List of dataTypes that are supported for use in data preparation task
 *
 * @type {Object}
 */
exports.SUPPORTED_METHODS = SUPPORTED_METHODS;
const SUPPORTED_PREPARED_DATA_TYPES = {
  FORM_DATA: 'FORM_DATA',
  JSON: 'JSON',
  URL_SEARCH_PARAMS: 'URL_SEARCH_PARAMS'
};
exports.SUPPORTED_PREPARED_DATA_TYPES = SUPPORTED_PREPARED_DATA_TYPES;